export const constants = {
    version: '1.3.0',
    //version: 'POR-011 [325]',
   // headerBackgroundColor: '#b51314'
  headerBackgroundColor:'#ebebeb'
}